var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"help"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"lv3Text t"},[_vm._v("法律声明")]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }